import React, {Component} from 'react';
import './Uploader.css';
import {Button,} from 'antd';
import 'react-datetime/css/react-datetime.css'
import Dropzone from "react-dropzone";
import {b64toBlob, checkIsPdf, showAxiosError} from "../../util/Helpers";
import Alert from "react-s-alert";
import EXIF from "exif-js";
import Resizer from 'react-image-file-resizer';
import {getMemberImage} from "../../util/APIUtils";
import FileSaver from "file-saver";
import {SERVER_IMAGE_PATH} from "../../constants";


class Uploader2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addToClassName:'',
            thumb:'',
            isLoading:false,
            file_:'',
            isModalVisible:false,
            fileUrl:"",
            viewFileModal:false,
        };
        this.onDrop = this.onDrop.bind(this);
        this.removeItem=this.removeItem.bind(this);
        this.downloadOriginalFile=this.downloadOriginalFile.bind(this);
        this.readExif=this.readExif.bind(this);
        this.createThumbNail=this.createThumbNail.bind(this);
        this.saveFile=this.saveFile.bind(this);
        this.viewFile = this.viewFile.bind(this);
    }

    componentDidMount() {
        //console.log("Uploader props",this.props);
        this.setState({file_ : this.props.file});
    }

    getBase64(file, cb) {
        //console.log("file, cb",file, cb);
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Base64 Read Error: ', error);
        };
    }

    async readExif(file){
        var self=this;
        var orientation;
        await EXIF.getData(file, function () {
            orientation = EXIF.getTag(this, "Orientation");
            if (orientation !== undefined) {
                if (orientation === 6) {
                    self.setState({addToClassName: ' rotate90'});
                } else if (orientation === 8) {
                    self.setState({addToClassName: ' rotate270'});
                } else if (orientation === 3) {
                    self.setState({addToClassName: ' rotate180'});
                }
            }
            return orientation;
        });
    }

    async createThumbNail(file, quality) {
        let self = this;
        let extension = file.name.toString().substring(file.name.toString().lastIndexOf('.') + 1);
        let fileType;
        let orientation;
        let rotation;
        (extension === 'jpg') ? (fileType = 'JPEG') : fileType = extension.toUpperCase();
        await EXIF.getData(file, function () {
            orientation = EXIF.getTag(this, "Orientation");
            /* if (orientation !== undefined) {
                 if (orientation == 6) {
                     self.setState({addToClassName: ' rotate90'});
                 } else if (orientation == 8) {
                     self.setState({addToClassName: ' rotate270'});
                 } else if (orientation == 3) {
                     self.setState({addToClassName: ' rotate180'});
                 }
             }*/
            if (orientation === 6)
                rotation = 90;
            else if (orientation === 3)
                rotation = 180;
            else if (orientation === 8)
                rotation = 270;
            Resizer.imageFileResizer(
                file,
                80,
                80,
                fileType,
                quality,
                rotation,
                thumb => {
                    self.props.onInfoChange(self.props.thumbFileName, thumb);
                },
                'base64'
            );
            self.props.onInfoChange(self.props.filePathName, SERVER_IMAGE_PATH + self.props.memberTCKN + '_' + self.props.pathPrefix + '.' + extension);
        });
    }

    onDrop(acceptedFiles, rejectedFiles) {
        var self=this;
        if (rejectedFiles.length > 0) {
            let validity='Yüklenecek Dosyalar 40MB\'dan Büyük Olamaz!'
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 10000
                });
        }
        else {
            if (self.props.parentComponent === "DocumentForm") {
                self.setState({file_: acceptedFiles[0]});
                self.props.onInfoChange(self.props.filePathName,SERVER_IMAGE_PATH+acceptedFiles[0].name);
            } else {
                this.getBase64(acceptedFiles[0], (result) => {
                    self.setState({file_: result});
                    self.props.onInfoChange(self.props.fileName, result);
                    if (!checkIsPdf(result)) {
                        //self.readExif(acceptedFiles[0]);
                        self.createThumbNail(acceptedFiles[0],100);
                    }
                    else {
                        self.props.onInfoChange(self.props.thumbFileName, result);
                        self.props.onInfoChange(self.props.filePathName,SERVER_IMAGE_PATH+self.props.memberTCKN+'_'+self.props.pathPrefix+'.pdf');
                    }
                });
            }
        }
    }

    async downloadOriginalFile(){
        let self=this;
        let fileName;
        let fileData;
        if((self.props.filePath!==null && self.props.filePath!=="") && self.state.file_==="") {
            self.setState({isLoading:true});
            await getMemberImage(self.props.filePath).then(response => {
                self.props.onInfoChange(self.props.fileName, response.data.base64File);
                self.setState({file_: response.data.base64File});
                fileName=response.data.filePath.toString().substring(response.data.filePath.toString().lastIndexOf('/')+1);
                fileData=response.data.base64File.toString().substring(response.data.base64File.toString().lastIndexOf(',')+1);
                var blob = b64toBlob(fileData,'');
                FileSaver.saveAs(blob, fileName);
                self.setState({isLoading: false});
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        }
    }

    saveFile(){
        let self=this;
        let fileName;
        let fileData;
        try{
            console.log("props: ", self.props.filePath);
            console.log("this.state.file_: ", this.state.file_);

            if(this.state.file_) {
                self.setState({isLoading:true});
                fileData = this.state.file_.toString().substring(this.state.file_.toString().lastIndexOf(',') + 1);
                fileName = this.props.filePath.toString().substring(this.props.filePath.toString().lastIndexOf('/') + 1);
                var blob = b64toBlob(fileData, '');
                FileSaver.saveAs(blob, fileName);
                self.setState({isLoading: false});
            }
        }catch(error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        }
    }

    viewFile() {
        this.setState({ isModalVisible: true, fileUrl: this.state.file_ });
    }

    cancelMemberCreation() {
        this.setState({
            viewFileModal: false,
        })
    }
    removeItem()
    {
        this.props.onInfoChange(this.props.fileName,'');
        this.props.onInfoChange(this.props.thumbFileName,'');
        this.props.onInfoChange(this.props.filePathName,'');
        this.setState({file_:''});
    }

    render() {
        return (
            <div className="uploader-container row col-sm-12">
                <Dropzone
                    accept=".jpg,.jpeg,.png,.pdf,.gif, application/pdf"
                    className="dropzone-container col-sm-9 fixed-height"
                    activeClassName="dropzoneActiveClass"
                    disabled={this.props.isDisabled || this.props.isFileAddDisabled}
                    multiple={false}
                    onDrop={this.onDrop}
                    maxSize={41943040}
                    initialFiles={[ this.props.thumb]}>
                    {
                        this.props.filePath === '' || this.props.filePath === null
                            ?
                            <div className="dropzone-text">
                                <img  alt="" className="add" src={require('../../icons8-plus-48.png')}/>
                                <span className="uploaderResponsive">Dosya seçmek için tıklayın.</span>
                            </div>
                            :
                            this.props.thumb === '' || this.props.thumb === null
                                ?
                                <div className="dropzone-text">
                                    <img  alt="" className="add" src={require('../../image_thumb.png')}/>
                                </div>
                                :
                                !checkIsPdf(this.props.thumb)
                                    ?
                                    <div className="dropzone-file">
                                        <img alt="" className={"thumbnail" +  this.state.addToClassName }  src={this.props.thumb}/>
                                    </div>
                                    :
                                    <div className="dropzone-file ">
                                        <img  alt="" className="thumbnail"   src={require('../../pdf_thumb.png')}/>
                                    </div>
                    }
                </Dropzone>
                <div className='buttonDiv col-sm-3'>
                <Button className="view-button" disabled={this.props.isDisabled} onClick={this.viewFile}/>
                <Button className={this.state.isLoading?'preview-button-loading':'preview-button'} disabled={this.props.isDisabled || this.state.isLoading}
                        onClick={async () => {(this.state.file_!=='') ? this.saveFile() : await this.downloadOriginalFile()}}/>
               <Button className="remove-button" disabled={this.props.isDisabled||this.props.isDeleteBtnDisabled} onClick={this.removeItem}/>

                </div>


                {/* <Modal isOpen={this.state.viewFileModal} size="lg" className="ust">
                <ModalHeader toggle={this.cancelFileCreation}>
                        Belgeniz
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                    {
                        this.state.fileUrl && !checkIsPdf(this.state.fileUrl) ?
                            <img src={this.state.fileUrl} alt="preview" style={{ width: '100%' }} /> :
                            <iframe src={this.state.fileUrl} title="preview" style={{ width: '100%', height: '500px' }}></iframe>
                    }
                      </ModalBody>
                </Modal> */}

            </div>
        );
    }
}
export default Uploader2;




// WEBPACK FOOTER //
// ./src/components/Uploader/Uploader2.js